import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';
import { validSettingKey, validSettingData } from '../../../lib/constants';
import { Setting } from '../../models/Setting';

const RequestDeviceInfoCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_DEVICE_INFO
  })
);

const RequestExitCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_EXIT
  })
);

const RequestTokenCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_TOKEN
  })
);

const RequestInstalledAppsCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_INSTALLED_APPS
  })
);

const RequestSettingCommand = Command.extend({
  detail: {
    key: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_SETTING
  })
);

const UpdateSettingCommand = Command.extend({
  detail: Setting
}).defaultTo(
  generateDefault({
    action: commandList.UPDATE_SETTING
  })
);

const RequestReloadCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_RELOAD
  })
);

const CheckRebootCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.CHECK_REBOOT
  })
);

export {
  RequestDeviceInfoCommand,
  RequestExitCommand,
  RequestTokenCommand,
  RequestInstalledAppsCommand,
  RequestSettingCommand,
  UpdateSettingCommand,
  RequestReloadCommand,
  CheckRebootCommand
};



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/commands/Device.js
 **/